//Service
import { EspecialistaAgendaService } from "src/app/core/services/especialista-agenda.service";
//Plugins
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

// calendar
import {
  CalendarOptions,
  EventApi,
  EventClickArg,
  CalendarApi,
} from "@fullcalendar/core";
import { FullCalendarComponent } from "@fullcalendar/angular";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import { FullCalendarModule } from "@fullcalendar/angular";

import { DatePipe, formatDate } from "@angular/common";
import Swal from "sweetalert2";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CitaService } from "src/app/core/services/cita.service";
import { Cita, Paciente } from "src/app/core/models";
//Services
import { CitasPagosService } from "src/app/core/services/citas-pagos.service";
import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";
import { TiposDocumentoService } from "src/app/core/services/tipos-documento.service";
import { ApisService } from "src/app/core/services/apis.service";
import { ParentescoService } from "src/app/core/services/parentesco.service";
import { SaldosService } from "src/app/core/services/saldos.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { CommonModule } from "@angular/common";
import { co } from "@fullcalendar/core/internal-common";
import { PaymentFormComponent } from "../../payment-form/payment-form.component";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-calendario",
  templateUrl: "./calendario.component.html",
  styleUrls: ["./calendario.component.scss"],
  standalone: true,
  imports: [
    FullCalendarModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CommonModule,
    PaymentFormComponent,
  ],
})
export class CalendarioComponent implements OnInit {
  @Input() datos: any; // Declara una propiedad de entrada para recibir los datos
  @ViewChild("fullcalendar", { static: false })
  fullcalendar: FullCalendarComponent;
  @ViewChild("confirmModal") confirmModal!: TemplateRef<any>;
  @ViewChild("createPaciente") createPaciente!: TemplateRef<any>;
  @ViewChild(PaymentFormComponent) paymentFormComponent: PaymentFormComponent;

  private modalReferences: { [key: string]: NgbModalRef } = {};

  showMoreHours: boolean = false;

  private lastRangeStart: Date | null = null;

  calendarOptions: CalendarOptions = {
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
    headerToolbar: {
      left: "",
      center: "title",
      right: "prev,next",
    },
    initialView: "timeGridThreeDay",
    views: {
      timeGridThreeDay: {
        type: "timeGrid",
        duration: { days: 3 },
        buttonText: "3 días",
        eventMinHeight: 40,
      },
    },
    themeSystem: "bootstrap",
    editable: false,
    selectMirror: true,
    dayMaxEvents: true,
    eventClick: this.handleEventClick.bind(this),
    allDaySlot: false,
    slotMinTime: "08:00:00",
    // slotMaxTime: this.showMoreHours ? '23:59:59' : '12:00:00',
    slotMaxTime: "22:00",
    height: "auto",
    contentHeight: "auto",
    handleWindowResize: true,

    hiddenDays: [0],
    locale: esLocale,
    defaultTimedEventDuration: "00:30:00",
    slotLabelInterval: "00:30:00",
    eventClassNames: ["custom-fc-event"],
    expandRows: true,
    slotDuration: "00:30:00",

    // slotLabelFormat: {
    //   hour: 'numeric',
    //   minute: '2-digit',
    //   omitZeroMinute: false,
    //   meridiem: 'short'
    // },
    dayHeaderFormat: { weekday: "short", day: "numeric" },
    nowIndicator: false,
    // eventTimeFormat: {
    //   hour: 'numeric',
    //   minute: '2-digit',
    //   meridiem: 'short'
    // },
    moreLinkContent: () => "Ver más horarios",
    moreLinkClick: "popover",
    slotLabelFormat: () => "",
    slotEventOverlap: false,
    datesSet: this.onDatesSet.bind(this), //evento para saber la fecha de rango actual

    validRange: {
      start: new Date(), // Esto establece la fecha mínima como hoy
    },

    eventContent: function (arg) {
      const formatTime = (timeText: string) => {
        const [hours, minutes] = timeText.split(":");
        let hour = parseInt(hours);
        const ampm = hour >= 12 ? "PM" : "AM";

        // Convertir a formato 12 horas
        hour = hour % 12;
        hour = hour ? hour : 12; // Si es 0, convertir a 12

        // Formatear con dos dígitos y agregar los minutos
        const formattedHour = hour.toString().padStart(2, "0");
        return `${formattedHour}:${minutes} ${ampm}`;
      };

      return {
        html: `
          <div class="fc-event-title-container">
            <div class="fc-event-title fc-sticky">${formatTime(
              arg.timeText
            )} <br> ${arg.event.title}</div>
          </div>`,
      };
    },
  };

  datosConfirmar = {
    nombresede: "",
    idSede: "",
    direccionSede: "",
    consultorio: "",
    fechaCita: "",
    fechaCitaFormateada: "",
    startEvent: null,
    horaCita: "",
    paciente: "",
  };

  formData: FormGroup;
  formDataPaciente: FormGroup;
  nombresede: string = "";
  direccionSede: string = "";
  consultorio: string = "";
  fechaCita: string = "";
  valorTotal: number = 0;
  valorServicio: number = 0;
  descuento: number = 0;
  servicios = [];
  serviciosEspecialista = [];
  idServiciosEspecialista = [];
  submitted: boolean;
  submittedPaciente: boolean;
  requiredContact: boolean = false;
  currentDate = new Date();
  tiposDocumento = [];
  //Ciudad
  paises: any = [];
  departamentos: any = [];
  ciudades: any = [];

  parentescos = [];
  paquetesPaciente = [];
  // Saldo a favor disponible del paciente. Es informativo para el modal:
  // el valor que realmente se aplica lo decide el backend en /saldo/aplicar.
  saldoDisponible: number = 0;
  // Paquete elegido por el paciente en el modal de forma de pago
  paqueteSeleccionadoId: string | null = null;
  servicioSeleccionado = null;
  idUsuarioAsigna: string;
  tUsuarioAsigna: string;
  nombreUsuarioAsigna: string;
  duracionCita: "30";

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private __especialistaAgendaService: EspecialistaAgendaService,
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private __tiposDocumentoService: TiposDocumentoService,
    private __citasPagosService: CitasPagosService,
    private __parentescoService: ParentescoService,
    private __serviciosService: ServiciosService,
    private __citasservice: CitaService,
    private __apisService: ApisService,
    private __saldosService: SaldosService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  private maxAttempts = 20;
  private currentAttempt = 0;
  private autoSearching = true; // Nueva bandera para controlar la búsqueda automática

  ngOnInit(): void {
    console.log("datos traidos del listado de especialistas::", this.datos);

    // DATOS DEL USUARIO ACTUAL LOGUEADO
    const currentUser = JSON.parse(localStorage.getItem("currentPatient"));

    this.idUsuarioAsigna = currentUser.userId;
    this.tUsuarioAsigna = currentUser.role;
    this.nombreUsuarioAsigna = currentUser.nombre;

    this.formData = this.fb.group({
      modalidad: ["Presencial", Validators.required],
      servicio: ["", Validators.required],
      duracion: ["", Validators.required],
      convenio: ["NO"],
      detalle: [""],
    });

    this.formDataPaciente = this.fb.group({
      nombres: ["", Validators.required],
      apellidos: ["", Validators.required],
      tDocumento: [null, Validators.required],
      identificacion: ["", Validators.required],
      celular: [, Validators.required],
      email: ["", [Validators.required, Validators.email]],
      fnacimiento: ["", Validators.required],

      contactoNombre: [""],
      contactoParentesco: [""],
      contactoTelefono: [""],
      idPaisResidencia: ["CO", Validators.required],
      idEstadoResidencia: [null, Validators.required], //DEPARTAMENTO
      idCiudadResidencia: [null, Validators.required],
    });

    // Trae los servicios que presta el especialista
    const today = new Date();
    this.serviciosEspecialista = this.datos.servicios.filter((servicio) => {
      const fDesde = new Date(servicio.fDesde);
      const fHasta = new Date(servicio.fHasta);
      return fDesde <= today && today <= fHasta;
    });

    this.getTiposDocumento((data: { documents: any[] }) => {
      this.tiposDocumento = data.documents;
    });
    this.getParentesco((data) => {
      this.parentescos = data;
    });

    setTimeout(() => {
      console.log("Iniciando búsqueda inicial");
      this.iniciarBusquedaEventos();
    });
  }

  // ngAfterViewInit() {
  //   // Asegurarse de que el calendario se actualice correctamente después de cargar nuevos eventos
  //   // this.fullcalendar.getApi().updateSize();
  // }

  // Agrega este método en tu componente para manejar el cambio de semana
  ngAfterViewInit() {
    if (this.fullcalendar) {
      const calendarApi = this.fullcalendar.getApi();

      // Observar cambios en el tamaño de la ventana
      window.addEventListener("resize", () => {
        setTimeout(() => {
          calendarApi.updateSize();
        }, 100);
      });
    }
  }

  private iniciarBusquedaEventos() {
    this.autoSearching = true;
    const dateRange = this.getCurrentDateRange();
    const startStr = dateRange.start.toISOString();
    const endStr = dateRange.end.toISOString();

    console.log("Buscando en rango:", { startStr, endStr });

    const formattedRange = {
      startStr: startStr,
      endStr: endStr,
      start: dateRange.start,
      end: dateRange.end,
    };

    this.getShedule(this.datos.$id, formattedRange);
  }

  private moveToNextRange() {
    console.log("Moviendo al siguiente rango");
    const calendarApi = this.fullcalendar.getApi();

    setTimeout(() => {
      calendarApi.next();
      // calendarApi.updateSize();
    }, 0);
  }

  async getShedule(idEspecialista: string, dateRange) {
    const date1 = new Date(dateRange.startStr);
    const fechaInicial = date1.toISOString().split("T")[0].toString();

    const date2 = new Date(dateRange.endStr);
    date2.setDate(date2.getDate());
    const fechaFinal = date2.toISOString().split("T")[0].toString();

    // console.log("Consultando API para fechas:", { fechaInicial, fechaFinal });

    this.__apisService
      .getTimeEspecialista(idEspecialista, fechaInicial, fechaFinal)
      .subscribe({
        next: (response) => {
          console.log("Respuesta API:", response);

          if (response["message"] && response["message"].length > 0) {
            console.log("Se encontraron eventos, mostrando en calendario");
            this.mostrarCitasEnCalendario(response["message"]);
            this.autoSearching = false;
            this.currentAttempt = 0;
          } else if (
            this.autoSearching &&
            this.currentAttempt < this.maxAttempts
          ) {
            console.log(
              "No hay eventos, avanzando al siguiente rango. Intento:",
              this.currentAttempt + 1
            );
            this.currentAttempt++;
            this.moveToNextRange();
          } else {
            console.log("Búsqueda finalizada sin eventos");
            this.autoSearching = false;
          }
        },
        error: (error) => {
          console.error("Error en la API:", error);
          this.autoSearching = false;
        },
      });
  }

  // 1. TRAE LA AGENDA DEL ESPECIALISTA, CITAS Y FILTRA
  // Llena horas para el calendario a mostrar!!!
  async getShedule_ORG(idEspecialista: string, dateRange) {
    console.log("datos ");

    // NUEVO DESDE ESTE MOMENTO SE VA A USAR LA NUEVA API.
    // {{url}}/getTimeEspecialista
    // Esta API obtiene las horas disponibles para tomar una cita.

    const date1 = new Date(dateRange.startStr);
    const fechaInicial = date1.toISOString().split("T")[0].toString();

    const date2 = new Date(dateRange.endStr);
    date2.setDate(date2.getDate() - 1); // restamos 1 día
    const fechaFinal = date2.toISOString().split("T")[0].toString();

    this.__apisService
      .getTimeEspecialista(idEspecialista, fechaInicial, fechaFinal)
      .subscribe({
        next: (response) => {
          this.mostrarCitasEnCalendario(response["message"]);
        },
        error: (error) => {
          console.error("Error:", error);
        },
        complete: () => {
          console.log("La solicitud se ha completado");
        },
      });
  }

  // 1.1. Filtro de agenda y comparación con las disponibilidad de un especialista
  filtrarAgenda(agenda: any[], citasAgendadas: any[]): any[] {
    // Función auxiliar para crear un objeto Date a partir de una fecha y hora
    function crearFecha(fechaStr: string, horaStr: string): Date {
      const [año, mes, dia] = fechaStr.split("-").map(Number);
      const [hora, minuto] = horaStr.split(":").map(Number);
      return new Date(año, mes - 1, dia, hora, minuto);
    }

    // Preprocesar las citas agendadas
    const citasPorFecha = citasAgendadas.reduce((acc, cita) => {
      const [fechaStr, horaStr] = cita.fechaCita.split("T");
      if (!acc[fechaStr]) {
        acc[fechaStr] = [];
      }
      const inicioCita = crearFecha(fechaStr, horaStr);
      const finCita = new Date(
        inicioCita.getTime() + parseInt(cita.duracionCita) * 60000
      );
      acc[fechaStr].push({ inicio: inicioCita, fin: finCita });
      return acc;
    }, {} as { [key: string]: { inicio: Date; fin: Date }[] });

    return agenda
      .map((diaAgenda) => {
        const fechaStr = diaAgenda.fecha.split("T")[0];
        const citasDelDia = citasPorFecha[fechaStr] || [];

        const horasDisponibles = diaAgenda.hora.filter((hora) => {
          const fechaHoraAgenda = crearFecha(fechaStr, hora);

          // Verificar si esta hora está disponible
          const estaOcupada = citasDelDia.some(
            (cita) =>
              fechaHoraAgenda >= cita.inicio && fechaHoraAgenda < cita.fin
          );

          if (estaOcupada) {
            console.log(
              `Hora ocupada: ${fechaHoraAgenda.toISOString()} - ${hora}`
            );
          }

          return !estaOcupada;
        });

        // Retornar el objeto con la estructura original, pero con las horas filtradas
        return {
          ...diaAgenda,
          hora: horasDisponibles,
        };
      })
      .filter((dia) => dia.hora.length > 0);
  }

  // 2. MUESTRA LAS CITAS EN EL CALENDARIO
  private mostrarCitasEnCalendario_ORG(agenda: any[]) {
    const calendarApi: CalendarApi = this.fullcalendar.getApi();
    calendarApi.removeAllEvents(); //borra todos los eventos

    // Usar una variable para controlar si se agregaron eventos
    let eventosAgregados = false;

    agenda.forEach((item) => {
      const { year, month, day } = this.extractDateComponents(item.fecha);

      // si es la fecha igual a hoy se suman 5 horas.
      if (this.isSameDate(item.fecha)) {
        item.horas_disponibles.forEach((itemHora) => {
          // MOSTRAR LAS HORAS MAYORES A LA DE AHORA Y LE SUMAMOS 5 horas con esta funcion: this.getCurrentTime()
          const objectHora = itemHora.hora.split(":");
          if (parseInt(objectHora[0], 10) > this.getCurrentTime()) {
            const dataCalendar = {
              title: "Sede " + itemHora.sede,
              start: new Date(
                year,
                month,
                day,
                parseInt(objectHora[0], 10),
                parseInt(objectHora[1], 10)
              ),
              allDay: false,
              className: "bg-primary text-white",
              groupId: itemHora.id,
            };
            calendarApi.addEvent(dataCalendar);

            eventosAgregados = true;
          }
        });
      } else {
        item.horas_disponibles.forEach((itemHora) => {
          const objectHora = itemHora.hora.split(":");
          const dataCalendar = {
            title: "Sede " + itemHora.sede,
            start: new Date(
              year,
              month,
              day,
              parseInt(objectHora[0], 10),
              parseInt(objectHora[1], 10)
            ),
            allDay: false,
            className: "bg-primary text-white",
            groupId: itemHora.id,
          };
          calendarApi.addEvent(dataCalendar);

          eventosAgregados = true;
        });
      }

      // Actualizar el tamaño del calendario una sola vez después de agregar todos los eventos
      // if (eventosAgregados) {
      //   // Usar setTimeout con un pequeño retraso para asegurar que todos los eventos se hayan renderizado
      //   setTimeout(() => {
      //     calendarApi.updateSize();
      //     // Forzar un scroll al inicio para asegurar que todo se vea correctamente
      //     calendarApi.scrollToTime('00:00:00');
      //   }, 100);
      // }
    });
  }

  private mostrarCitasEnCalendario(agenda: any[]) {
    const calendarApi: CalendarApi = this.fullcalendar.getApi();

    // Primero limpiamos eventos
    calendarApi.removeAllEvents();

    // Recopilamos todos los eventos primero
    const eventos = [];

    agenda.forEach((item) => {
      const { year, month, day } = this.extractDateComponents(item.fecha);

      if (this.isSameDate(item.fecha)) {
        item.horas_disponibles.forEach((itemHora) => {
          const objectHora = itemHora.hora.split(":");
          if (parseInt(objectHora[0], 10) > this.getCurrentTime()) {
            eventos.push({
              title: "Sede " + itemHora.sede,
              start: new Date(
                year,
                month,
                day,
                parseInt(objectHora[0], 10),
                parseInt(objectHora[1], 10)
              ),
              allDay: false,
              className: "bg-primary text-white",
              groupId: itemHora.id,
            });
          }
        });
      } else {
        item.horas_disponibles.forEach((itemHora) => {
          const objectHora = itemHora.hora.split(":");
          eventos.push({
            title: "Sede " + itemHora.sede,
            start: new Date(
              year,
              month,
              day,
              parseInt(objectHora[0], 10),
              parseInt(objectHora[1], 10)
            ),
            allDay: false,
            className: "bg-primary text-white",
            groupId: itemHora.id,
          });
        });
      }
    });

    // Agregamos todos los eventos de una vez
    calendarApi.addEventSource(eventos);

    // Forzamos múltiples actualizaciones para asegurar el renderizado correcto
    setTimeout(() => {
      calendarApi.updateSize();
      calendarApi.scrollToTime("02:00:00");

      // Primera actualización
      requestAnimationFrame(() => {
        calendarApi.updateSize();

        // Segunda actualización después de un pequeño delay
        setTimeout(() => {
          calendarApi.updateSize();
        }, 100);
      });
    }, 150);
  }

  // #############################################################################################
  // TOMAR LA CITA

  // 3. EVENTO CLICK EN LA HORA DESDE EL CALENDARIO
  handleEventClick(clickInfo: EventClickArg) {
    const id_agenda_especialista = clickInfo.event.groupId;
    // console.log("id_agenda_especialista", id_agenda_especialista);

    this.__especialistaAgendaService
      .getDocument(id_agenda_especialista)
      .then((res: any) => {
        // console.log("DATOS DE LA HORA DE LA AGENDA SELECCIONADA:::::::....", res);

        // this.datosConfirmar.fechaCita = formatDate(clickInfo.event.start, 'd-MMM-yyyy HH:mm', 'es-ES');
        this.datosConfirmar.fechaCita = formatDate(
          clickInfo.event.start,
          "d-MMM-yyyy HH:mm",
          "en-US"
        );
        this.datosConfirmar.fechaCitaFormateada = formatDate(
          clickInfo.event.start,
          "d-MMM-yyyy hh:mm aaa",
          "es-ES"
        );

        this.datosConfirmar.startEvent = clickInfo.event.start;
        this.datosConfirmar.nombresede = res.idSedeConsultorio.idSede.sede;
        this.datosConfirmar.idSede = res.idSedeConsultorio.idSede.$id;
        this.datosConfirmar.direccionSede =
          res.idSedeConsultorio.idSede.direccion;
        this.datosConfirmar.consultorio = res.idSedeConsultorio.descripcion;

        // CHECKEAR SI ES ONLINE O NO.
        const modalidadInicial =
          this.datosConfirmar.idSede === "online" ? "Online" : "Presencial";

        this.formData.patchValue({
          modalidad: modalidadInicial,
        });

        this.getServiciosByModalidad();
      });

    if (this.datos.datosPaciente) {
      this.getServiciosByModalidad();
      this.datosConfirmar.paciente =
        this.datos.datosPaciente.nombres +
        " " +
        this.datos.datosPaciente.apellidos;
      this.modalService.open(this.confirmModal, { centered: true });
      this.consultarPaquetesPaciente(this.datos.datosPaciente.$id);
      this.consultarSaldoPaciente(this.datos.datosPaciente.$id);
    } else {
      const modalRef = this.modalService.open(this.createPaciente, {
        centered: true,
      });
      this.modalReferences["createPaciente"] = modalRef;
    }
  }
  // 4. El paciente toma la cita luego de seleccionar servicio y modalidad y escribir el detalle
  confirmarCita() {
    this.submitted = true;
    if (this.formData.invalid) {
      return;
    } else {
      // SI LA DURACION DE LA CITA ES DE 60 MINUTOS O MAS
      if (this.formData.value.duracion >= "60") {
        console.log("DURACIÓN CITA: :", this.formData.value.duracion);
        const calendarApi = this.fullcalendar.getApi().getEvents();
        const validacionHorarioSiguiente = this.validarDuracionHora(
          this.datosConfirmar.startEvent,
          calendarApi,
          this.formData.value.duracion
        );
        if (!validacionHorarioSiguiente) {
          Swal.fire({
            icon: "error",
            title:
              "El horario seleccionado no está disponible para el tiempo solicitado",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      this.confirmarResumenCita();
    }
  }

  // Resumen de la cita antes de solicitarla, para que el paciente confirme
  // los datos. Al aceptar se continúa con la forma de pago.
  async confirmarResumenCita() {
    const paquetesAplicables = this.paquetesPaciente.filter(
      (paquete) => this.clasificarPaquete(paquete).aplica
    );

    const fila = (etiqueta: string, valor: any) => `
      <div style="display:flex;justify-content:space-between;gap:1rem;padding:.3rem 0;border-bottom:1px solid #f1f2f4">
        <span style="color:#74788d">${etiqueta}</span>
        <strong style="text-align:right">${valor || "-"}</strong>
      </div>`;

    let html = `<div style="text-align:left">`;
    html += fila("Paciente", this.datosConfirmar.paciente);
    html += fila("Especialista", this.datos?.nombre);
    html += fila(
      "Fecha y hora",
      this.datosConfirmar.fechaCitaFormateada || this.datosConfirmar.fechaCita
    );
    html += fila("Modalidad", this.formData.value.modalidad);
    html += fila("Servicio", this.servicioSeleccionado?.servicio);
    html += fila("Duración", `${this.formData.value.duracion} minutos`);
    html += fila(
      "Sede",
      this.datosConfirmar.idSede === "online"
        ? "Online"
        : `${this.datosConfirmar.nombresede} · Consultorio ${this.datosConfirmar.consultorio}`
    );
    html += fila("Total", `$${this.valorTotal}`);
    html += fila(
      "Forma de pago",
      paquetesAplicables.length > 0
        ? "Programa o pago, la eliges en el siguiente paso"
        : "La eliges en el siguiente paso"
    );

    if (this.formData.value.detalle) {
      html += fila("Motivo de consulta", this.formData.value.detalle);
    }

    html += `</div>`;

    const confirmacion = await Swal.fire({
      title: "Confirma los datos de tu cita",
      html,
      showCancelButton: true,
      confirmButtonColor: "#2ab57d",
      confirmButtonText: "Confirmar y continuar",
      cancelButtonText: "Volver",
    });

    if (confirmacion.isConfirmed) {
      this.validaSiTienePaquete();
    }
  }

  // Devuelve el $id de una relación de Appwrite (o el valor si viene como texto)
  idRelacion(valor: any): string {
    return (valor?.$id ?? valor ?? "").toString();
  }

  // Determina si un paquete aplica a la cita que se está agendando.
  // Deben coincidir la modalidad y el tipo de terapia (psicología /
  // neuropsicología), además de quedarle citas disponibles. El tipo de consulta
  // (control / primera vez), a quién va dirigido y la duración NO se comparan:
  // por decisión de negocio no bloquean el uso del paquete.
  clasificarPaquete(paquete: any) {
    const servicioPaquete = paquete?.idServicio;

    const modalidadCita = (this.formData.value.modalidad || "")
      .toString()
      .trim()
      .toLowerCase();
    const modalidadPaquete = (servicioPaquete?.modalidad || "")
      .toString()
      .trim()
      .toLowerCase();

    const coincideModalidad =
      !!modalidadCita && modalidadCita === modalidadPaquete;

    const tipoTerapiaCita = this.idRelacion(this.servicioSeleccionado?.tTerapia);
    const coincideTerapia =
      !!tipoTerapiaCita &&
      tipoTerapiaCita === this.idRelacion(servicioPaquete?.tTerapia);

    const tieneCitas = paquete?.citasRestantes > 0;

    const motivos = [];
    if (!coincideModalidad) {
      motivos.push(
        `Modalidad ${servicioPaquete?.modalidad || "sin definir"} (tu cita es ${this.formData.value.modalidad})`
      );
    }
    if (!coincideTerapia) {
      motivos.push(
        `Terapia ${servicioPaquete?.tTerapia?.terapia || "distinta"} (tu cita es ${
          this.servicioSeleccionado?.tTerapia?.terapia || "otra"
        })`
      );
    }
    if (!tieneCitas) {
      motivos.push("Sin citas disponibles");
    }

    return {
      aplica: coincideModalidad && coincideTerapia && tieneCitas,
      motivos,
    };
  }

  // Construye el listado de paquetes del paciente para el modal de forma de pago.
  // Se muestran TODOS los paquetes: los que aplican a la modalidad y al tipo de
  // terapia seleccionados quedan resaltados y seleccionables; el resto se
  // muestra atenuado, indicando por qué no aplica.
  construirHtmlPaquetes(paquetes: any[]): string {
    const nombrePaquete = (paquete: any) =>
      paquete?.idServicio?.servicio || "Paquete";
    const detallePaquete = (paquete: any) => {
      const detalles = [];
      if (paquete?.idServicio?.tTerapia?.terapia) {
        detalles.push(paquete.idServicio.tTerapia.terapia);
      }
      if (paquete?.idServicio?.modalidad) {
        detalles.push(paquete.idServicio.modalidad);
      }
      if (paquete?.idServicio?.duracion) {
        detalles.push(`${paquete.idServicio.duracion} min`);
      }
      return detalles.join(" · ");
    };

    // Los que aplican primero, para que queden a la vista
    const clasificados = paquetes
      .map((paquete) => ({ paquete, ...this.clasificarPaquete(paquete) }))
      .sort((a, b) => Number(b.aplica) - Number(a.aplica));

    let html = `<div style="text-align:left">`;
    html += `<p style="margin-bottom:.5rem">Cita seleccionada: <strong>${
      this.servicioSeleccionado?.servicio || "-"
    }</strong> · <strong>${this.formData.value.modalidad}</strong></p>`;
    html += `<p style="margin-bottom:.75rem;color:#74788d"><small>Estos son tus programas. Los resaltados aplican a esta cita; selecciona de cuál quieres descontarla, o elige 'Prefiero pagar esta cita' para no gastar tu paquete.</small></p>`;

    let primeroAplicable = true;
    clasificados.forEach(({ paquete, aplica, motivos }) => {
      const detalle = detallePaquete(paquete);

      if (aplica) {
        const checked = primeroAplicable ? "checked" : "";
        primeroAplicable = false;
        html += `
          <label style="display:block;border:2px solid #2ab57d;background:#f1fbf7;border-radius:6px;padding:.6rem .75rem;margin-bottom:.5rem;cursor:pointer">
            <input type="radio" name="paqueteSeleccionado" value="${paquete.$id}" ${checked} style="margin-right:.5rem">
            <strong>${nombrePaquete(paquete)}</strong>
            <span style="background:#2ab57d;color:#fff;border-radius:4px;padding:0 .35rem;font-size:11px;margin-left:.35rem">Aplica</span><br>
            <small style="color:#74788d">${
              detalle ? detalle + " · " : ""
            }Citas restantes: <strong>${paquete.citasRestantes}</strong></small>
          </label>`;
      } else {
        html += `
          <div style="border:1px dashed #dfe3e8;border-radius:6px;padding:.5rem .75rem;margin-bottom:.4rem;opacity:.6">
            <strong>${nombrePaquete(paquete)}</strong><br>
            <small style="color:#74788d">${
              detalle ? detalle + " · " : ""
            }Citas restantes: <strong>${paquete.citasRestantes}</strong></small><br>
            <small style="color:#f1734f">No aplica: ${motivos.join(" · ")}</small>
          </div>`;
      }
    });

    html += `</div>`;
    return html;
  }

  // 5. a. Valida si tiene paquete
  async validaSiTienePaquete() {
    this.paqueteSeleccionadoId = null;

    if (this.paquetesPaciente.length > 0) {
      const aplicables = this.paquetesPaciente.filter(
        (paquete) => this.clasificarPaquete(paquete).aplica
      );

      if (aplicables.length > 0) {
        return Swal.fire({
          title: "Forma de pago de tu cita ",
          html: this.construirHtmlPaquetes(this.paquetesPaciente),
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: "#2ab57d",
          confirmButtonText: "Descontar del programa",
          denyButtonText: "Prefiero pagar esta cita",
          denyButtonColor: "#4F95BE",
          cancelButtonText: `Cancelar`,
          preConfirm: () => {
            const seleccionado = document.querySelector(
              'input[name="paqueteSeleccionado"]:checked'
            ) as HTMLInputElement;
            if (!seleccionado) {
              Swal.showValidationMessage(
                "Selecciona el programa del que se descontará la cita"
              );
              return false;
            }
            return seleccionado.value;
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.paqueteSeleccionadoId = result.value;
            this.createCitaValidada("PAQUETE");
          } else if (result.isDenied) {
            // El paciente tiene paquete pero prefiere no gastarlo en esta cita
            this.preguntarFormaPago();
          }
        });
      }
    }

    // Si no tiene paquetes O tiene paquetes pero ninguno aplica a esta cita
    return this.preguntarFormaPago();
  }

  // Modal de pago en línea / en consultorio
  preguntarFormaPago() {
    // Informativo: el saldo que se aplica de verdad lo calcula /saldo/aplicar
    const saldoAplicable = Math.min(this.saldoDisponible, this.valorTotal);
    const aCobrar = Math.max(0, this.valorTotal - saldoAplicable);
    // El saldo cubre la cita completa: no se abre Wompi ni queda nada por pagar
    const citaCubierta = aCobrar === 0;

    const money = (valor: number) => "$" + valor.toLocaleString("es-CO");

    const bloqueSaldo =
      saldoAplicable > 0
        ? `<div class="alert alert-success mt-2 mb-0">
             Tienes <strong>${money(this.saldoDisponible)}</strong> de saldo a favor.
             Se aplicarán <strong>${money(saldoAplicable)}</strong> a esta cita
             ${citaCubierta ? "y no tendrás que pagar nada." : ""}
           </div>`
        : "";

    // Con la cita cubierta no hay pasarela ni pago en consultorio que ofrecer
    const bloqueMediosPago = citaCubierta
      ? ""
      : `<br>Paga en línea tu consulta, vía PSE, Tarjetas Débito, Crédito, Nequi. <br> Puedes pagar en el momento de confirmar la cita.`;

    return Swal.fire({
      title: "Forma de pago de tu cita ",
      html: `
            Total de la cita: <strong>${money(this.valorTotal)}</strong><br>
            Total a pagar: <strong>${money(aCobrar)}</strong>
            ${bloqueSaldo}
            ${bloqueMediosPago}
        `,
      // "En consultorio" solo se oculta cuando el saldo cubre el total: ahí
      // haría exactamente lo mismo que confirmar, y prometería un cobro que no
      // existe. Con saldo parcial o sin saldo sigue siendo una opción válida.
      showDenyButton: !citaCubierta,
      showCancelButton: true,
      confirmButtonColor: "#2ab57d",
      confirmButtonText: citaCubierta
        ? "Confirmar cita con mi saldo"
        : saldoAplicable > 0
        ? `Pagar ${money(aCobrar)} en línea`
        : "Pago en línea",
      denyButtonText:
        saldoAplicable > 0
          ? `Pagar ${money(aCobrar)} en consultorio`
          : `En consultorio`,
      denyButtonColor: "#4F95BE",
      cancelButtonText: `Cancelar`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ONLINE también cuando el saldo cubre todo: el saldo que se muestra es
        // informativo y puede haber cambiado desde que se abrió el modal. Si el
        // backend devuelve un restante, esta rama lo cobra por Wompi; con
        // CONSULTORIO quedaría un pago pendiente que nadie avisó.
        this.createCitaValidada("ONLINE");
      } else if (result.isDenied) {
        this.createCitaValidada("CONSULTORIO");
      }
    });
  }

  // 4.a. VALIDA QUE NO EXISTA UN CITA EN EL MISMO RANGO DE TIEMPO
  async validaCita() {
    // const citas = await this.__citasservice.getCitasAndValidate('66c3d5ad352263f44fdc','14-Dec-2024 11:30');
    console.log("FECHA CITA::", this.datosConfirmar.fechaCita);
    const citas = await this.__citasservice.getCitasAndValidate(
      this.datos.$id,
      this.datosConfirmar.fechaCita
    );
    if (citas.length > 0) {
      console.log("EXISTE OTRA CITA");
      return true;
    }
    console.log("NO EXISTE OTRA CITA ESTA DISPONIBLE PUEDE CONTINUAR");
    return false;
  }

  // 5. CREA LA CITA.
  // MODO: ONLINE, CONSULTORIO, PAQUETE
  async createCitaValidada(modoPago) {
    let citasRestantes = 0;

    // Se valida si aún esta disponible ese horario para ese especialista.
    const validacionHorario = await this.validaCita();
    if (validacionHorario) {
      Swal.fire({
        icon: "error",
        title:
          "El horario seleccionado ya no está disponible para el tiempo solicitado",
        showConfirmButton: true,
        confirmButtonText: "Cerrar",
        timer: 3000,
        didClose: () => {
          this.modalService.dismissAll();
          this.router.navigate(["/"]);
        },
      });
      return;
    }

    const cita: any = {
      detalle: this.formData.value.detalle,
      VrServicio: this.valorServicio,
      VrDescuento: parseInt(this.descuento.toString(), 10),
      VrTotal: this.valorTotal,
      idEstadoCita: "agendada",
      fechaCita: this.datosConfirmar.fechaCita,
      idSede: this.datosConfirmar.idSede,
      modalidad: this.formData.value.modalidad,
      servicioId: this.formData.value.servicio,
      IdEstadoPago: "creada",
      idPaciente: this.datos.datosPaciente.$id,
      duracionCita: this.formData.value.duracion.toString(),
      idEspecialista: this.datos.$id,
      tUsuarioAsigna: this.tUsuarioAsigna,
      idUsuarioAsigna: this.idUsuarioAsigna,
      nombreUsuarioAsigna: this.nombreUsuarioAsigna,
      convenio: this.formData.value.convenio === "SI" ? true : false,
      idConvenio:
        this.formData.value.convenio === "SI"
          ? this.datos.datosPaciente.idConvenio.$id
          : null,
    };
    console.log(cita);

    try {
      if (modoPago === "PAQUETE") {
        // Se resuelve el paquete ANTES de crear la cita: si no se encuentra, la
        // cita quedaría marcada como pagada con paquete sin descontar nada.
        const paqueteEncontrado = this.paquetesPaciente.find(
          (paquete) => paquete.$id === this.paqueteSeleccionadoId
        );

        if (!paqueteEncontrado) {
          console.error(
            "No se encontró el paquete seleccionado:",
            this.paqueteSeleccionadoId
          );
          await Swal.fire({
            icon: "error",
            title: "No se pudo agendar con el programa",
            text: "No encontramos el programa seleccionado. Por favor intenta de nuevo.",
            confirmButtonText: "Cerrar",
          });
          return;
        }

        console.log("Paquete encontrado::", paqueteEncontrado);
        citasRestantes = paqueteEncontrado.citasRestantes - 1;

        cita.IdEstadoPago = "paquete";
        // Se guarda de qué paquete se descontó, para poder devolver la sesión
        // exactamente a ese paquete si la cita se cancela o se reprograma.
        cita.idPaqueteAdquirido = paqueteEncontrado.$id;

        // CREACIÓN DE LA CITA!!!!
        const createCita = await this.__citasservice.createDocument(cita);
        console.log("createCita:: PAQUETE", createCita);

        // La sesión se descuenta DESPUÉS de crear la cita: si la creación
        // falla, el paciente no debe perder la sesión.
        const restarPaquete =
          await this.__paquetesAdquiridosService.updateDocument(
            paqueteEncontrado.$id,
            { citasRestantes: citasRestantes }
          );
        console.log("Restar paquete::", restarPaquete);

        Swal.fire({
          icon: "success",
          title: "Tu cita se ha agendado",
          text:
            "Se ha descontado una cita de su programa, le quedan " +
            citasRestantes +
            " citas",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      if (modoPago === "ONLINE" || modoPago === "CONSULTORIO") {
        // CREACIÓN DE LA CITA!!!!
        const createCita = await this.__citasservice.createDocument(cita);
        console.log("createCita::", modoPago, createCita);

        // ARREGLADO POR RAFAEL PARA QUE GUARDE LA CITA
        // El mensaje de confirmación lo muestra pasarelaPago, porque depende
        // de si el saldo a favor alcanzó a cubrir la cita completa.
        await this.pasarelaPago(createCita.$id, this.valorTotal, modoPago);
      }

      this.modalService.dismissAll();
      this.router.navigate(["/"]);
    } catch (error) {
      console.log(error);
    }
  }

  // 6. ARREGLADO POR RAFAEL: recibe idCita sin el "c_"
  async pasarelaPago(idCita, valor, modoPago) {
    // 6.a. Antes de cobrar nada, se intenta cubrir la cita con el saldo a favor.
    // Es idempotente por cita, así que un doble click no gasta el saldo dos veces.
    const saldo = await this.aplicarSaldoACita(idCita, valor);

    // Lo que realmente hay que cobrar. Si /saldo/aplicar falló, es el valor completo.
    const montoACobrar = saldo ? saldo.valorRestante : valor;

    if (saldo?.citaCubierta) {
      // El backend ya creó el citas_pagos con referencia c_<idCita>_saldo.
      // No se crea otro registro ni se abre Wompi.
      await Swal.fire({
        icon: "success",
        title: "Tu cita se ha agendado!",
        text:
          "La cita quedó pagada con tu saldo a favor. Te queda un saldo de $" +
          saldo.saldoRestante,
        showConfirmButton: false,
        timer: 4000,
      });
      return;
    }

    const dataCitaPago = {
      idCita: idCita,
      IdEstadoPago: "creada",
      referencia: "c_" + idCita,
      fechaPago: new Date(),
      valor: montoACobrar,
      descripcion: "Compra Cita",
    };

    console.log("dataCitaPago::", dataCitaPago);

    const createCitaPago = await this.__citasPagosService.createDocument(
      dataCitaPago
    );
    console.log("createCitaPago::", createCitaPago);

    if (modoPago === "ONLINE") {
      console.log("modo online::");
      Swal.fire({
        icon: "success",
        title: "Tu cita se ha agendado!",
        text: "En este momento vas a ser redireccionado a la pasarela de pagos.",
        showConfirmButton: false,
        timer: 3000,
      });
      // La firma se calcula sobre el monto que se va a cobrar, no sobre el total
      // de la cita: si no coinciden, Wompi rechaza el checkout.
      this.paymentFormComponent.signature = await this.generateHash(
        "c_" + idCita,
        montoACobrar
      );
      this.paymentFormComponent.amountInCents = montoACobrar;
      this.paymentFormComponent.reference = "c_" + idCita;
      if (this.paymentFormComponent) {
        this.paymentFormComponent.submitPayment();
      }
    } else {
      await Swal.fire({
        icon: "success",
        title: "Tu cita se ha agendado!",
        text: "Tu pago será recibido en Consultorio o desde tu panel de control.",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }

  /**
   * Aplica el saldo a favor a la cita recién creada.
   * Devuelve null si la llamada falla: en ese caso se cobra el valor completo,
   * que es exactamente el comportamiento anterior a esta funcionalidad.
   */
  async aplicarSaldoACita(idCita: string, valorCita: number) {
    try {
      const respuesta = await this.__saldosService.aplicarSaldo(
        this.datos.datosPaciente.$id,
        idCita,
        valorCita
      );
      console.log("saldo aplicado::", respuesta);
      return respuesta;
    } catch (error) {
      console.error("No se pudo aplicar el saldo a favor:", error);
      return null;
    }
  }

  // ##########################################################################
  // FUNCIONES VARIAS

  // Comprueba si realmente se ha movido a un nuevo rango

  // Modificamos onDatesSet para respetar la búsqueda automática
  onDatesSet(dateInfo: any) {
    console.log("onDatesSet llamado", {
      autoSearching: this.autoSearching,
      dateInfo,
    });

    const currentRange = this.getCurrentDateRange();
    if (dateInfo.start.getTime() !== this.lastRangeStart?.getTime()) {
      this.lastRangeStart = dateInfo.start;
      this.getShedule(this.datos.$id, dateInfo);
    }
  }

  onDatesSet_ORG(dateInfo: any) {
    const currentRange = this.getCurrentDateRange();
    if (dateInfo.start.getTime() !== this.lastRangeStart?.getTime()) {
      this.lastRangeStart = dateInfo.start;
      // Trae los eventos del nuevo rango
      this.getShedule(this.datos.$id, dateInfo);
    }
  }

  // SABER EN QUE RANGO DEL CALENDARIO ESTOY
  getCurrentDateRange() {
    const calendarApi: CalendarApi = this.fullcalendar.getApi();
    const start = calendarApi.view.activeStart;
    const end = calendarApi.view.activeEnd;
    return { start, end };
  }

  // funcion para validar si la fecha es la de hoy.
  isSameDate(dateString: string): boolean {
    // Convertir la fecha recibida a objeto Date
    const receivedDate = new Date(dateString);

    // Obtener la fecha actual
    const today = new Date();

    // Comparar año, mes y día
    return (
      receivedDate.getUTCFullYear() === today.getUTCFullYear() &&
      receivedDate.getUTCMonth() === today.getUTCMonth() &&
      receivedDate.getUTCDate() === today.getUTCDate()
    );
  }
  // funcion para obtener la fecha en y, m y d
  extractDateComponents(dateString: string): {
    year: number;
    month: number;
    day: number;
  } {
    const date = new Date(dateString);

    return {
      year: date.getUTCFullYear(),
      // getUTCMonth() devuelve un valor de 0-11, así que sumamos 1 para obtener 1-12
      month: date.getUTCMonth(),
      day: date.getUTCDate(),
    };
  }

  getParentesco(dataComp) {
    this.__parentescoService.getData().then((data) => {
      dataComp(data);
    });
  }

  getPaises() {
    this.__apisService.getCountries().subscribe((result) => {
      this.paises = result;
    });
  }

  getStatesCountries(event) {
    // Si event existe, usa su valor
    const valorSeleccionado = event ? event.iso2 : "CO";
    this.__apisService
      .getStatesCountries(valorSeleccionado)
      .subscribe((result) => {
        console.log(result);
        this.departamentos = result;
      });
  }

  getCiudades(event) {
    // Si event existe, usa su valor
    const valorSeleccionado = event ? event.id : "2890"; //2890 es el id de antioquia
    this.__apisService
      .getCitiesCountries(valorSeleccionado)
      .subscribe((result) => {
        this.ciudades = result;
      });
  }

  getTiposDocumento(dataComp) {
    this.__tiposDocumentoService.getTiposDocumento().then((data) => {
      dataComp(data);
    });
  }

  // Rafael
  // Función para obtener solo los ids de los servicios que presta el especialista
  // Toma solo los ids y devuelve un array para luego filtrar en los servicios a mostrar
  dataServiceArray() {
    return this.serviciosEspecialista.map((dato) => dato.servicioId.$id);
  }

  closeModal() {
    this.activeModal.close(); // Cierra el modal
  }

  moverDatosConfirmar() {}

  // Rafael
  // Aquí están solo los ids de los servicios que están activos que presta el especialista
  getServiciosByModalidad() {
    const dataArray = this.dataServiceArray();
    console.log("Ids de servicios activos por especialista::", dataArray);

    this.formData.get("servicio").reset();
    this.servicios = [];

    this.__serviciosService
      .getDocumentsByModalidadIncludeArray(
        this.formData.value.modalidad,
        dataArray
      )
      .then((data) => {
        // this.servicios = data;

        // Rafael
        // Filtra que los servicios sean para el especialista

        this.servicios = data.filter((servicio) => {
          const isColombian =
            this.datos.datosPaciente.idPaisResidencia === "CO";
          console.log("isColombian::", isColombian);
          const isCopValid = servicio.valorCop > 0;
          const isUsdValid = servicio.valorUsd > 0;
          return (isColombian && isCopValid) || (!isColombian && isUsdValid);
        });
        // console.log("DATA SERVICIOS:", this.servicios);
      });

    // this.__serviciosService
    //   .getDocumentsByModalidad(this.formData.value.modalidad)
    //   .then((data) => {
    //     // Rafael
    //     // Filtra que los servicios sean para el especialista

    //     this.servicios = data.filter((servicio) => {
    //       const isColombian =
    //         this.datos.datosPaciente.idPaisResidencia === "CO";
    //       console.log("isColombian::", isColombian);
    //       const isCopValid = servicio.valorCop > 0;
    //       const isUsdValid = servicio.valorUsd > 0;
    //       return (
    //         dataArray.includes(servicio.$id) &&
    //         ((isColombian && isCopValid) || (!isColombian && isUsdValid))
    //       );
    //     });
    //     console.log("DATA SERVICIOS:", this.servicios);
    //     // this.servicios = data.filter(servicio => {

    //     //   // Rafael Filtrar para que solo muestre los servicios que presta un especialista
    //     //   dataArray.includes(servicio.$id)

    //     //   console.log('DATA SERVICIOS:', servicio)
    //     //   console.log('DATA ESPECIALISTA:',this.serviciosEspecialista)
    //     //   const isColombian = this.datos.datosPaciente.pais === 'CO';
    //     //   const isCopValid = servicio.valorCop > 0;
    //     //   const isUsdValid = servicio.valorUsd > 0;
    //     //   return (isColombian && isCopValid) || (!isColombian && isUsdValid);
    //     // });
    //   });
  }

  // Selecciona el servicio
  changeServicio(event) {
    this.servicioSeleccionado = event;

    this.valorServicio = 0;
    if (event != undefined) {
      if (event.duracion) {
        this.formData.get("duracion").setValue(event.duracion);
        this.duracionCita = event.duracion;
      } else {
        this.formData.get("duracion").setValue(30);
      }

      if (this.datos.datosPaciente.pais == "CO") {
        this.valorServicio = event.valorCop;
      } else {
        this.valorServicio = event.valorUsd;
      }
    }
    this.calcularValorTotal();
  }

  selectDate____(fecha) {
    this.requiredContact = this.validarMenorEdad(fecha);

    if (this.requiredContact) {
      this.formDataPaciente
        .get("contactoNombre")
        .setValidators([Validators.required]);
      this.formDataPaciente
        .get("contactoParentesco")
        .setValidators([Validators.required]);
      //  this.formDataPaciente.get('contactoTelefono').setValidators([Validators.required]);
    } else {
      this.formDataPaciente.get("contactoNombre").clearValidators();
      this.formDataPaciente.get("contactoParentesco").clearValidators();
      this.formDataPaciente.get("contactoTelefono").clearValidators();
    }
    this.formDataPaciente.get("contactoNombre").updateValueAndValidity();
    this.formDataPaciente.get("contactoParentesco").updateValueAndValidity();
    this.formDataPaciente.get("contactoTelefono").updateValueAndValidity();
  }

  /**
   *
   * @param fecha
   * @returns
   */
  validarMenorEdad(fecha: Date) {
    const hoy = new Date();
    const fechaNacimiento = new Date(fecha);

    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mes = hoy.getMonth() - fechaNacimiento.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
      edad--;
    }
    if (edad < 18) {
      return true;
    } else {
      return false;
    }
  }

  /**
   *
   * @param event
   */
  selectConvenio(event) {
    console.log("event", event);

    if (event.target.value == "SI") {
      if (
        this.datos.datosPaciente.idConvenio.requiereAprobacion &&
        this.tUsuarioAsigna === "PACIENTE"
      ) {
        Swal.fire({
          icon: "error",
          title: `Por favor, comuníquese con el Call Center al teléfono +57 314 813 1016`,
          showConfirmButton: true,
          // timer: 1500
        });
        this.selectNoConvenio();
      } else {
        //
        // this.formData.get('convenio').setValue(this.datos.datosPaciente.idConvenio.$id);
        this.descuento = this.datos.datosPaciente.idConvenio.descuento;
      }
    } else {
      this.descuento = 0;
    }

    // if (event.target.value == "SI") {
    //   this.formData.get('convenio').setValue(this.datos.datosPaciente.idConvenio.$id);
    //   this.descuento = this.datos.datosPaciente.idConvenio.descuento;
    // } else {
    //   this.formData.get('convenio').setValue('');
    //   this.descuento = 0;
    // }

    this.calcularValorTotal();
  }

  // Método para cambiar programáticamente a 'No'
  selectNoConvenio() {
    // this.formData.get('convenio').setValue('NO');
    this.formData.patchValue({
      convenio: "NO",
    });
    console.log(
      "DATA CONVENIO CUANDO CAMBIA SELECTNOCONVENIO: ",
      this.formData.value
    );
  }

  /**
   *
   */
  calcularValorTotal() {
    this.valorTotal =
      this.valorServicio - (this.valorServicio * this.descuento) / 100;
  }

  /**
   * changeModalidad()
   * @param event
   */
  changeModalidad(event) {
    this.valorTotal = 0;
    this.getServiciosByModalidad();
  }

  /**
   * get form()
   */
  get form() {
    return this.formData.controls;
  }

  /**
   * Returns form
   */
  get formPacientes() {
    return this.formDataPaciente.controls;
  }

  /* 
  TRAE TODOS LOS EVENTOS :: events es un array
  TRAE LA FECHA DEL EVENTO :: newEventStart
  TRAE LA DURACIÓN :: duracion pueden
  */
  validarDuracionHora(
    newEventStart: Date,
    events: EventApi[],
    duracion: number
  ): boolean {
    const dateSelected = new Date(newEventStart);
    const numBloques = duracion / 30; // Calcula cuántos bloques de 30 minutos necesitamos verificar

    for (let i = 1; i < numBloques; i++) {
      // Comienza desde 1 porque el bloque inicial ya está seleccionado
      const bloqueAVerificar = new Date(dateSelected);
      bloqueAVerificar.setMinutes(bloqueAVerificar.getMinutes() + i * 30);

      // Verifica si NO existe un evento que comience en este bloque
      const existeEvento = events.some((event) => {
        const eventStart = new Date(event.start);
        return eventStart.getTime() === bloqueAVerificar.getTime();
      });

      if (!existeEvento) {
        return false; // Si no encuentra un evento en cualquiera de los bloques necesarios, retorna false
      }
    }

    return true; // Si encuentra eventos en todos los bloques necesarios, retorna true
  }

  /**
   *
   * @param idPago
   * @param monto monto que se va a cobrar. Debe ser el mismo que se manda a Wompi
   *              en amount-in-cents: si difiere, la pasarela rechaza el checkout.
   * @returns
   */
  async generateHash(idPago: string, monto: number = this.valorTotal) {
    const valor = monto;
    const cadenaConcatenada =
      idPago + valor * 100 + "COP" + environment.wompi.testIntegrity;
    console.log(cadenaConcatenada);
    //Ejemplo
    const encondedText = new TextEncoder().encode(cadenaConcatenada);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encondedText);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // "37c8407747e595535433ef8f6a811d853cd943046624a0ec04662b17bbf33bf5"
    return hashHex;
  }

  /**
   * Trae los paquetes adquiridos de un paciente
   * @param idPaciente
   */
  /**
   * Trae el saldo a favor del paciente. Si falla se deja en 0 y se sigue:
   * el saldo nunca debe bloquear el agendamiento.
   * @param idPaciente
   */
  async consultarSaldoPaciente(idPaciente: string) {
    try {
      const respuesta = await this.__saldosService.getMiSaldo(idPaciente);
      this.saldoDisponible = respuesta?.saldo ?? 0;
    } catch (error) {
      console.error("No se pudo consultar el saldo a favor:", error);
      this.saldoDisponible = 0;
    }
  }

  async consultarPaquetesPaciente(idPaciente: string) {
    const paquetesPaciente =
      await this.__paquetesAdquiridosService.getDataByPaciente(idPaciente);
    this.paquetesPaciente = paquetesPaciente;
    console.log("PAQUETES PACIENTE::", paquetesPaciente);
  }

  // FUNCION PARA OBTENER LA HORA ACTUAL DEL SISTEMA
  getCurrentTime(): number {
    let newDate = new Date(this.currentDate.getTime());
    newDate.setHours(newDate.getHours() + 5);
    return newDate.getHours();
  }
}
